import { gql } from '@apollo/client';
export const EMPLOYER_FIELDS = gql `
  fragment EmployerFields on Employer {
    id
    name
    createdAt
    updatedAt
  }
`;
export const EMPLOYERS = gql `
  ${EMPLOYER_FIELDS}
  query EMPLOYERS {
    employers {
      ...EmployerFields
    }
  }
`;
